import React, { useState } from "react";
import * as pmm from "@afe/pmm-sdk";
import ErrorUi from "./ErrorUi";
import ErrorBoundary from ".";

/**
 * 项目的白屏处理
 */
export default function ProjectErrorBoundary(props) {
  const [copyStr, setCopyStr] = useState<string>();

  /**
   * 处理页面白屏时的报错
   * @param error
   */
  function handlePageError(error) {
    // 要求项目必须接入pmm，不然报错无法上报
    try {
      // 最终只上报白屏的报错，因为最终上报的信息里面已经包含了导致白屏的报错
      if (error) {
        uploadError("captureException", new Error("页面白屏"));
      }
    } catch (e) {
      uploadError("captureMessage", e.message);
    }
  }

  /**
   * 上报错误
   * @param api 调用的方法
   * @param error 报错内容
   */
  function uploadError(api: string, error: Error) {
    try {
      setCopyStr(pmm[api]?.(error));
    } catch (e) {
      console.log(`pmm ${api} 调用出错`, e);
    }
  }

  return (
    <ErrorBoundary
      copyStr={copyStr}
      onError={handlePageError}
      FallbackComponent={ErrorUi}
    >
      {props.children}
    </ErrorBoundary>
  );
}
